/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S10_BodyInputs */

const tr_servis_s10_body = /** @type {(inputs: Servis_S10_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Servis Sözleşmesi'nde yapılacak esaslı değişiklikler en az 30 gün önceden e-posta ve Platform içi bildirimlerle duyurulur. Değişikliği kabul etmemeniz halinde yürürlük tarihinden önce aboneliğinizi feshedebilirsiniz.`)
};

const en_servis_s10_body = /** @type {(inputs: Servis_S10_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material changes to this Service Agreement are announced at least 30 days in advance by e-mail and by notifications within the Platform. If you do not accept the change, you may terminate your subscription before the effective date.`)
};

const de_servis_s10_body = /** @type {(inputs: Servis_S10_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentliche Änderungen an diesem Servicevertrag werden mindestens 30 Tage im Voraus per E-Mail und über Benachrichtigungen innerhalb der Plattform angekündigt. Wenn Sie die Änderung nicht akzeptieren, können Sie Ihr Abonnement vor dem Wirksamkeitsdatum kündigen.`)
};

const ru_servis_s10_body = /** @type {(inputs: Servis_S10_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Существенные изменения настоящего Сервисного договора объявляются не менее чем за 30 дней по электронной почте и через уведомления внутри Платформы. Если вы не принимаете изменение, вы можете расторгнуть подписку до даты вступления изменения в силу.`)
};

/**
* | output |
* | --- |
* | "Material changes to this Service Agreement are announced at least 30 days in advance by e-mail and by notifications within the Platform. If you do not accept..." |
*
* @param {Servis_S10_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s10_body = /** @type {((inputs?: Servis_S10_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S10_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s10_body(inputs)
	if (locale === "de") return de_servis_s10_body(inputs)
	if (locale === "ru") return ru_servis_s10_body(inputs)
	return tr_servis_s10_body(inputs)
});